import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Card, Col, Flex, Row, Skeleton } from 'antd';
import { DefaultPageLayout } from 'layouts/default-page-layout';
import { useGetClient } from 'api/clients/use-get-client.ts';
import { ClientType } from 'types/client';
import { ECommentEntityName } from 'types/comment.ts';
import { AddClientUserButton } from 'components/client-users/add-client-user-button';
import { ClientUsersList } from 'components/client-users/client-users-list';
import { ClientDescription } from 'components/clients/client-description';
import { ClientFactoringAlert } from 'components/clients/client-factoring-alert';
import { ClientInsurance } from 'components/clients/client-insurance';
import { ClientMain } from 'components/clients/client-main';
import { ClientPageHeader } from 'components/clients/client-page-header';
import { CommentsCard } from 'components/comments/comments-card';
import { EntityAuditLogs } from 'components/common/audit-logs';
import { ContactsList } from 'components/contacts/contacts-list';

export const ClientPage = () => {
  const { clientId } = useParams();
  const { t } = useTranslation();

  const { data: client, isLoading } = useGetClient(Number(clientId));

  return (
    <DefaultPageLayout header={!isLoading && client ? <ClientPageHeader client={client} /> : undefined}>
      {!isLoading && client ? (
        <>
          <Row gutter={16}>
            <Col span={17}>
              <Flex gap='middle' vertical>
                <ClientMain clientId={client.id} />
                <EntityAuditLogs entityType='client' entityId={client.id} />
              </Flex>
            </Col>
            <Col span={7}>
              <Flex gap={15} vertical>
                {client.factoringEnabled ? <ClientFactoringAlert /> : null}
                {client.type === ClientType.carrier ? <ClientInsurance clientId={client.id} /> : null}
                <Card title={t('common:contacts')}>
                  <ContactsList clientId={client.id} />
                </Card>
                {client.description ? (
                  <Card title={t('common:description')}>
                    <ClientDescription description={client.description} />
                  </Card>
                ) : null}
                <Card extra={<AddClientUserButton clientId={client.id} />} title={t('client:accesses')}>
                  <ClientUsersList clientId={client.id} />
                </Card>
                <CommentsCard entityName={ECommentEntityName.client} entityId={client.id} />
              </Flex>
            </Col>
          </Row>
        </>
      ) : (
        <Skeleton />
      )}
    </DefaultPageLayout>
  );
};
